// import { getUserSettings } from '../../../Redux/AccountSettings/accountSettingsAction';
import './profile-details.scss';

import { Button } from 'antd';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { trackButtonClick } from '../../../analytics/mixpanel';
import InlineStyled from '../../../CommonComponents/InlineStyled/InlineStyled';
import { AUTH_URL } from '../../../config';
import { DOC_COMPARE } from '../../../Constants/commonConstants';
import { loginStateSelector, userDataSelector } from '../../../Redux/login/loginReducer';
import { getExternalLink } from '../../../utils/functions';

const ProfileDetails = ({ product }) => {
  const navigate = useNavigate();
  const loginState = useSelector(loginStateSelector);
  const userData = useSelector(userDataSelector);
  const organisationDetails = userData?.organisation || {};

  const formattedDate = useMemo(() => {
    if (!userData?.dateJoined) return '';

    return new Date(userData?.dateJoined).toLocaleDateString('en-IN', {
      dateStyle: 'long',
    });
  }, [userData?.dateJoined]);

  return (
    <>
      <InlineStyled
        $style={{
          color: '#01142A',
          fontFamily: 'Inter',
          fontSize: '24px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: 'normal',
          marginBottom: '24px',
        }}
      >
        Profile
      </InlineStyled>
      <div className='user-details-container'>
        <article className='row'>
          <div>
            <h4>Organisation Details</h4>
            <div className='color-n8'>
              Give information about your organisation so your users know who they are a part
              of.{' '}
            </div>
          </div>
          <div className='grid-2'>
            <div>
              <h4>Organisation Name</h4>
              <p>{organisationDetails?.name ?? '-'}</p>
            </div>
            <div>
              <h4>Organisation Address</h4>
              <p>{organisationDetails.address ?? '-'}</p>
            </div>
            <div>
              <h4>Communication Email</h4>
              <p>{organisationDetails.communicationEmail ?? '-'}</p>
            </div>
            <div>
              <h4>{product === DOC_COMPARE ? 'DocCompare' : 'DocChat'} Quota</h4>
              <p>
                {loginState[product === DOC_COMPARE ? 'docCompareQuota' : 'docChatQuota'] ?? '-'}
              </p>
            </div>
          </div>
        </article>
        <article className='row'>
          <div>
            <h4>My Details</h4>
            <div className='color-n8'>Give information about yourself.</div>
          </div>
          <div className='grid-2'>
            <div className='edit-details'>
              <div>
                <h4>Full Name</h4>
                <p>{userData?.name ?? '-'}</p>
              </div>
              <Button
                type='primary'
                className='btn-m'
                onClick={async () => {
                  trackButtonClick({ type: 'Edit Profile Details' });
                  const link = await getExternalLink(`${AUTH_URL}/profile`);
                  navigate(link);
                }}
              >
                Edit Details
              </Button>
            </div>
            <div>
              <h4>Official Email ID</h4>
              <p>{userData?.email ?? '-'}</p>
            </div>
            <div>
              <h4>Contact Number</h4>
              <p>{userData?.phoneNumber ?? '-'}</p>
            </div>
          </div>
        </article>
        <article className='row'>
          <div>
            <h4>Subscription Details</h4>
            <div className='color-n8'>Details about your subscription.</div>
          </div>
          <div className='grid-2'>
            <div>
              <h4>User Since</h4>
              <p>{formattedDate ?? '-'}</p>
            </div>
          </div>
        </article>
      </div>
    </>
  );
};

export default ProfileDetails;
